const colors = require('tailwindcss/colors');
const plugin = require('tailwindcss/plugin');
/** @type {import('tailwindcss').Config} */
module.exports = {
    content: [
        'httpdocs/templates/*.tpl',
        'httpdocs/templates/**/*.tpl',
        'httpdocs/javascriptnew/*.js',
        'httpdocs/javascriptnew/**/*.js',
        'php/classes/*.php',
    ],
    safelist: [
        'tracking-widest',
        'text-tiny',
        'text-4xl',
        '!w-2/4',
        'mt-16',
        'bg-primary-darker',
        'fixed',
        'rounded-lg',
        'h-[20px]',
        'h-[40px]',
        'h-[60px]',
        'h-[80px]',
        'h-[100px]',
        'h-[120px]',
        'h-[140px]',
        'h-[160px]',
        'max-w-180',
        'md:max-w-180',
        'md:max-w-150',
        'max-w-150',
        'max-w-110',
        'max-h-30',
        'max-w-[100%]',
        'md:max-w-[75%]',
        'max-h-[100%]',
        'md:max-h-[75%]',
        'pb-carousel',
        'opacity-50',
        'opacity-70',
        'opacity-65',
        'pb-opacity-50',
        'pb-opacity-70',
        'pb-opacity-65',
        'pb-hidden-desktop',
        'pb-hidden-mobile',
    ],
    theme: {
        container: {
            center: true,
            padding: {
                DEFAULT: '0.5rem',
                sm: '1rem',
            },
        },
        letterSpacing: {
            tighter: '-.05em',
            normal: '0',
            wider: '.05em',
            widest: '.22em',
        },

        color: {
            transparent: 'transparent',
            current: 'currentColor',
        },

        dropShadow: {
            DEFAULT: '0 3px 4px hsla(0, 0%, 0%, 0.2)',
            'menu': '0 4px 15px hsla(0, 0%, 0%, 0.15)',
            'btn': '0 1px 8px 0 hsla(0, 0%, 0%, 0.12)',

        },
        fontFamily: {
            sans: ['Noto Sans', 'sans-serif'],
            display: ['Outfit', 'sans-serif'],
        },
        screens: {
            'sm': '640px',
            'md': '768px',
            'lg': '1024px',
            'xl': '1158px',
            '2xl': '1415px', // Opgepast ook in variables voorzien
        },
        extend: {
            aspectRatio: {
                '5/9': '5 / 9',
            },
            blur: {
                xs: '3px',
            },
            borderRadius: {
                'large': '1.25rem',
                'inherit': 'inherit',
            },
            boxShadow: {
                'dropdown': '0 5px 15px rgba(0,0,0,0.15)',
                'swiper-btn': '0px 1px 8px rgba(0, 0, 0, 0.12)',
                'overview': '0px 2px 10px 0 rgba(0, 0, 0, 0.15)',
                'pagebuilder': '0 5px 15px 0 hsla(0, 0%, 0%, 0.15)',
            },
            colors: {
                neutral: {
                    0: 'hsla(0, 8%, 100%, 1)',
                    100: 'hsla(0, 8%, 97%, 1)',
                    200: 'hsla(0, 0%, 85%, 1)',
                    300: 'hsla(0, 0%, 70%, 1)',
                    400: 'hsla(0, 0%, 51%, 1)',
                    500: 'hsla(0, 0%, 45%, 1)',
                    'darkgray': 'hsla(208, 15%, 17%, 1)',
                    'gradient': 'hsla(0, 0, 0, 0.6)',
                    'grey': 'hsla(0, 0%, 67%, 1)',
                    DEFAULT: 'hsla(194, 9%, 30%, 1)',
                },
                primary: {
                    50: 'hsla(171, 35%, 93%, 1)',
                    100: 'hsla(165, 44%, 96%, 1)',
                    200: 'hsla(170, 34%, 86%, 1)',
                    300: 'hsla(170, 38%, 74%, 1)',
                    400: 'hsla(170, 52%, 61%, 1)',
                    mint: 'hsla(170, 75%, 40%, 1)',
                    heavymint: 'hsla(170, 64%, 59%, 1)',
                    jade: 'hsla(178, 83%, 30%, 1)',
                    dark: 'hsla(176, 82%, 12%, 1)',
                    darker: 'hsla(176, 81%, 11%, 1)',
                    DEFAULT: 'hsla(176, 81%, 20%, 1)',
                },
                accent: {
                    orange100: 'hsla(32, 100%, 98%, 1)',
                    orange400: 'hsla(32, 100%, 44%, 1)',
                    orange500: 'hsla(32, 100%, 47%, 1)',
                    red: 'hsla(358, 86%, 47%, 1)',
                    orange: 'hsla(32, 100%, 54%, 1)',
                    lime400: 'hsla(64, 100%, 33%, 1)',
                    lime500: 'hsla(64, 100%, 36%, 1)',
                    lime: 'hsla(64, 100%, 43%, 1)',
                    blue: 'hsla(209, 86%, 60%, 1)',
                    DEFAULT: 'hsla(209, 86%, 60%, 1)',
                },
                honey: 'hsla(42, 88%, 56%, 1)',
                hotpink: 'hsla(336, 100%, 50%, 1)',
                warning: 'hsla(15, 86%, 47%, 1)',
                shadow: 'hsla(0, 0%, 0%, 0.3)',
                grey: 'hsla(0, 0%, 91%, 1)',
            },
            fontSize: {
                'xtiny': '.65rem',
                'tiny': '.87rem',
                'xxs': '.68rem',
                '2.5xl': '1.75rem',
                '3.75xl': '2rem',
                '4xl': '2.5rem',
                '4.5xl': '2.5rem',
            },
            fontWeight: {
                'medium': 500,
                'semibold': 600,
            },
            fontFamily: {
                display: ['Outfit', 'sans-serif'],
            },
            gradientDegree: {
                45: '45deg',
            },
            gridAutoRows: {
                'minmax': 'minmax(min-content, max-content)',
            },
            height: {
                16: '1rem',
                22: '1.375rem',
                '30': '1.875rem',
                '40': '2.5rem',
                '70': '4.375rem',
                360: '22.5rem',
                430: '26.875rem',
                '170': '10.625rem',
                '180': '11.25rem',
                '280': '17.5rem',
                '136': '8.5rem',
                '150': '9.375rem',
                '310': '19.375rem',
                '373': '23.3125rem',
                '445': '27.8125rem',
                '500': '31.25rem',
                120: '120%',
            },
            inset: {
                '16per': '16.5%',
                80: '20rem',
            },
            lineClamp: {
                7: '7',
                8: '8',
                9: '9',
                10: '10',
            },
            lineHeight: {
                'large': '3rem',
            },
            maxHeight: {
                '26': '1.625rem',
                '30': '1.875rem',
                '89': '5.5625rem',
                '160': '10rem',
                '166': '10.375rem',
                'half': '50%',
                '280': '17.5rem',
                '150': '9.375rem',
                '373': '23.3125rem',
                '500': '31.25rem',
            },
            maxWidth: {
                '40': '2.5rem',
                '45': '2.8125rem',
                '50': '3.125rem',
                '70': '4.375rem',
                '89': '5.5625rem',
                '94': '5.875rem',
                '110': '6.875rem',
                '120': '7.5rem',
                '150': '9.375rem',
                '160': '10rem',
                '180': '11.25rem',
                '210': '13.125rem',
                '221': '13.8125rem',
                '275': '17.1875rem',
                '300': '18.75rem',
                '320': '20rem',
                '347': '21.6875rem',
                '400': '25rem',
                '452': '28.25rem',
                '500': '31.25rem',
            },
            minHeight: {
                '86': '5.375rem',
                '120': '7.5rem',
                '144': '9rem',
                '150': '9.375rem',
                '160': '10rem',
                '174': '10.875rem',
                '180': '11.25rem',
                '250': '15.625rem',
                '275': '17.1875rem',
                '280': '17.5rem',
                '343': '21.4375rem',
                '430': '26.875rem',
                '80vh': '80vh',
            },
            minWidth: {
                '120': '120px',
                '160': '160px',
                '170': '170px',
                '180': '11.25rem',
                '210': '13.125rem',
                '225': '14.0625rem',
                '250': '15.625rem',
                '300': '18.75rem',
                '305': '19.0625rem',
                '415': '415px',
            },
            opacity: {
                '35': '.35',
                '65': '.65',
            },
            ringOffsetWidth: {
                '3': '3px',
            },
            spacing: {
                '9px': '0.5625rem',
                3.7: '42%',
                13: '3.25rem',
                15: '3.75rem',
                17: '4.25rem',
                18: '4.5rem',
                19: '4.75rem',
                21: '5.25rem',
                22: '5.50rem',
                23: '5.75rem',
                34: '8.75rem',
                42: '10.5rem',
                70: '4.375rem',
                98: '27.81rem',
            },
            textUnderlineOffset: {
                9: '14px',
            },
            transitionProperty: {
                'height': 'max-height',
            },
            width: {
                16: '1rem',
                22: '1.375rem',
                25: '2rem',
                '30': '1.875rem',
                '40': '2.5rem',
                50: '3.125rem',
                '70': '4.375rem',
                80: '20rem',
                96: '24rem',
                98: '27.81rem',
                110: '6.875rem',
                132: '8.25rem',
                150: '9.375rem',
                305: '19.0625rem',
                767: '47.9375rem',
                120: '120%',
            },
            zIndex: {
                '-1': '-1',
                '2': '2',
                '5': '5',
                '7': '7',
                'full': '9999',
            },
            animation: {
                'slide-in-blurred-top': 'slide-in-blurred-top .6s cubic-bezier(.23,1.000,.32,1.000) both',
                'scale-in-center': 'scale-in-center 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both',
                'scale-in-top': 'scale-in-top 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both',
                'scale-out-center': 'scale-out-center 0.3s cubic-bezier(0.550, 0.085, 0.680, 0.530) both',
            },
            keyframes: {
                'scale-in-center': {
                    '0%': {
                        transform: 'scale(0)',
                        opacity: '1',
                    },
                    '100%': {
                        transform: 'scale(1)',
                        opacity: '1',
                    },
                },
                'scale-out-center': {
                    '0%': {
                        transform: 'scale(1)',
                        opacity: '1',
                    },
                    '100%': {
                        transform: 'scale(0)',
                        opacity: '1',
                    },
                },
                'slide-in-blurred-top': {
                    '0%': {
                        'transform': 'translateY(-1000px) scaleY(2.5) scaleX(0.2)',
                        'transform-origin': '50% 0%',
                        filter: 'blur(40px)',
                        opacity: '0',
                    },
                    '100%': {
                        'transform': 'translateY(0) scaleY(1) scaleX(1)',
                        'transform-origin': '50% 50%',
                        filter: 'blur(0)',
                        opacity: '1',
                    },
                },
                'scale-in-top': {
                    '0%': {
                        'transform': 'scaleY(0)',
                        'transform-origin': '50% 0%',
                        opacity: '0',
                    },
                    '100%': {
                        'transform': 'scaleY(1)',
                        'transform-origin': '50% 0%',
                        opacity: '1',
                    },
                },
            },

            typography: (theme) => ({
                DEFAULT: {
                    css: getDefault(theme, {
                        lineHeight: theme('fontSize.base.1'),
                        p: {
                            lineHeight: theme('lineHeight.6'),
                            fontWeight: theme('fontWeight.normal'),
                            '&.text-4xl': {
                                lineHeight: theme('lineHeight.large'),
                            },
                        },
                        h1: {
                            color: theme('colors.primary.DEFAULT'),
                            fontFamily: theme('fontFamily.display.0'),
                            fontSize: theme('fontSize.2xl'),
                            fontWeight: theme('fontWeight.semibold'),
                            lineHeight: theme('lineHeight.7'),
                            '&.text-4xl': {
                                lineHeight: theme('lineHeight.large'),
                            },
                        },
                        h2: {
                            fontFamily: theme('fontFamily.display.0'),
                            color: theme('colors.primary.DEFAULT'),
                            fontSize: theme('fontSize.xl.0'),
                            fontWeight: theme('fontWeight.semibold'),
                            lineHeight: theme('lineHeight.7'),
                        },
                        h3: {
                            fontSize: theme('fontSize.lg.0'),
                            fontWeight: theme('fontWeight.semibold'),
                        },
                        a: {
                            color: theme('colors.primary.mint'),
                            textDecoration: 'no-underline',
                            fontWeight: theme('fontWeight.normal'),
                            '&:hover': {
                                color: theme('colors.primary.mint'),
                                textDecoration: 'underline',
                            },
                        },
                        maxWidth: '100%',
                    }),
                },

                sm: {
                    css: getDefault(theme),
                },
            }),
        },
    },
    plugins: [
        'postcss-import',
        'tailwindcss',
        'autoprefixer',
        require('@tailwindcss/forms')({
            strategy: 'base',
        }),
        require('@tailwindcss/typography'),
        require('@tailwindcss/line-clamp'),
        plugin(function ({matchUtilities, theme}) {
            matchUtilities(
                {
                    'gradient-degree': (angle) => ({
                        'background-image': `linear-gradient(${angle}, var(--tw-gradient-stops))`,
                    }),
                },
                {
                    // values from config and defaults you wish to use most
                    values: Object.assign(
                        theme('gradientDegree', {}), // name of config key. Must be unique
                        {
                            153: '153.01deg',
                            158: '158.22deg',
                            173: '173.66deg',
                            180: '180deg',
                        },
                    ),
                },
            );
        }),
    ],
};

// -- functie voor de prose standaard kan aangevuld/overruled worden door options param
function getDefault(theme, options = {}) {
    return {

        '--tw-prose-body': theme('colors.neutral.DEFAULT'),
        '--tw-prose-bullets': theme('colors.neutral.DEFAULT'),
        '--tw-prose-counters': theme('colors.neutral.DEFAULT'),

        ul: {
            listStylePosition: 'outside',
            listStyleType: 'disc',
            paddingLeft: '1.3em',
        },
        ol: {
            listStylePosition: 'outside',
            paddingLeft: '1.3em',
        },

        ...options,

    };
}
